export default class CarrierCommissionSerializer {
  static serialize(data) {
    return {
      commissionMin: data.commissionMin,
      commissionPercent: data.commissionPercent
    };
  }

  static deSerialize(data) {
    return {
      commissionMin: data.commissionMin,
      commissionPercent: data.commissionPercent
    };
  }
}